import { Link } from 'react-router-dom';
import type { CompanyProfile } from '@/lib/companyProfile';

// Bloc 1 — en-tête vendeur (lecture seule, alimenté par les paramètres).
export default function InvoiceHeaderBlock({ profile }: { profile: CompanyProfile }) {
  const address = [profile.address, [profile.postal_code, profile.city].filter(Boolean).join(' '), profile.country]
    .filter(Boolean)
    .join(' · ');

  const ids = [
    profile.ice ? `ICE : ${profile.ice}` : '',
    profile.if_number ? `IF : ${profile.if_number}` : '',
    profile.rc_number ? `RC : ${profile.rc_number}` : '',
    profile.tp_number ? `TP : ${profile.tp_number}` : '',
  ].filter(Boolean);

  return (
    <section className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5">
      <div className="flex items-start justify-between gap-3 mb-3">
        <h3 className="text-sm font-semibold text-foreground-900 flex items-center gap-2">
          <i className="ri-building-2-line text-primary-500"></i>
          Bloc 1 · Votre entreprise
        </h3>
        <Link
          to="/dashboard/finance/parametres"
          className="text-xs text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer no-underline"
        >
          Modifier
        </Link>
      </div>

      <div className="flex items-start gap-3">
        {profile.logo_url ? (
          <span className="w-14 h-14 rounded-lg border border-background-200/70 bg-white flex items-center justify-center overflow-hidden flex-shrink-0">
            <img src={profile.logo_url} alt="Logo" className="max-w-full max-h-full object-contain" />
          </span>
        ) : (
          <span className="w-14 h-14 rounded-lg bg-background-100 text-foreground-400 flex items-center justify-center flex-shrink-0">
            <i className="ri-store-3-line text-xl"></i>
          </span>
        )}
        <div className="min-w-0 text-xs text-foreground-600 space-y-0.5">
          <p className="text-sm font-bold text-foreground-950 truncate">
            {profile.company_name || 'Nom de l’entreprise à renseigner'}
            {profile.legal_form && <span className="font-normal text-foreground-500"> · {profile.legal_form}</span>}
          </p>
          {address && <p className="truncate">{address}</p>}
          <p className="truncate">{[profile.phone, profile.email].filter(Boolean).join(' · ') || 'Coordonnées à renseigner'}</p>
          {ids.length > 0 ? (
            <p className="flex flex-wrap gap-x-3 gap-y-0.5 text-foreground-500">{ids.map((id) => <span key={id}>{id}</span>)}</p>
          ) : (
            <Link to="/dashboard/finance/parametres" className="text-accent-700 font-medium no-underline">
              Ajoutez ICE, IF, RC et TP pour une facture conforme
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}